export const enum Partition {
  Training = "Training",
  Validation = "Validation",
  Inference = "Inference",
}
